import * as React from 'react';
import { useCartStore } from 'src/hooks/cart';
import { __remove, __set } from 'src/store/axios_indicator';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import System from 'src/helper/system';

const ClearCartPopup = (props) => {
    const { SetStatus } = props;
    const [{ }, {  }, { clear_cart }] = useCartStore();
    const [{ }, { clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const { translation:t } = System;

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const clearedAllCart = async () => {
            __set('CART_API_CALL')
            await clear_cart({ miniCart: true });
            clear_all_system_alert({})

            __remove('CART_API_CALL')

        onHide()
    };

    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{t('cartClearAll')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="text-center mt-3 mb-5">
                            <p className="mb-0">{t('clearCartPermanentAction')}</p>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm" data-dismiss="modal"
                                onClick={() => { onHide() }}>
                                {t('cancel')}
                            </button>
                            <button onClick={() => { clearedAllCart() }}
                                type="button" className="bs5 btn btn-primary btn-sm w145">
                                {t('continue')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ClearCartPopup;